<template>
  <div class="news_details_wrap news-detail-page">
    <PCNavbar selectIndex="4-2"/>
    <MobileNavBar :currentActive="3"/>
    <div class="news_content">
      <el-breadcrumb class="news_bread" separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>新闻详情</el-breadcrumb-item>
      </el-breadcrumb>

      <article class="news_article">
        <header class="news_article_header">
          <h1 class="news_title">
            携手济南静态交通集团 和谐广场地铁口首批二轮充电桩投入运营
          </h1>
          <div class="news_meta">
            <span class="news_meta_item">来源：山东智能工业装备公司</span>
            <span class="news_meta_sep">·</span>
            <span class="news_meta_item">投稿时间：2026-07-02</span>
          </div>
        </header>

        <div class="article_body">
          <p class="lead">
            继济南静态交通集团领导来我司考察交流后，双方首个合作项目现已正式落地。我司为济南和谐广场地铁口量身打造的二轮智能充电桩设备已全部完成交付、安装与调试，目前已全面投入运营使用。
          </p>

          <figure class="figure_block">
            <img
              class="article_img"
              :src="images.img1"
              alt="济南和谐广场地铁口"
            >
            <figcaption class="figure_caption">项目落地位置 &mdash; 济南和谐广场地铁口</figcaption>
          </figure>

          <h2 class="section_title">一、从考察交流到项目落地</h2>

          <p class="body_paragraph">
            2026年4月23日，济南静态交通集团张总、周总、邓总三位领导莅临我司开展指导工作，双方围绕两轮充电桩代工业务、电池健康监测功能模块研发、共享充电设备试点等方向达成了初步合作意向。经过两个多月的紧密对接与方案论证，双方决定以济南和谐广场地铁口作为首个试点区域，由我司提供二轮智能充电桩设备，正式开启合作的第一步。
          </p>

          <h2 class="section_title">二、设备交付与安装</h2>

          <p class="body_paragraph">
            本次交付的二轮智能充电桩设备，严格按照济南静态交通集团提供的技术参数标准进行生产，在产品安全与质量方面层层把关。设备沿和谐广场地铁口周边非机动车停放区统一规划部署，采用栏式一体化安装方案，既规范了电动车停放秩序，又实现了充电服务的就近可达。目前所有设备已安装完毕并通过调试验收，全面进入正式运营状态。
          </p>

          <figure class="figure_block">
            <img
              class="article_img"
              :src="images.img2"
              alt="充电桩安装现场全景"
            >
            <figcaption class="figure_caption">充电桩安装现场 &mdash; 设备沿非机动车停放区统一部署</figcaption>
          </figure>

          <h2 class="section_title">三、产品功能与使用体验</h2>

          <p class="body_paragraph">
            本次投入运营的智能充电桩支持微信扫码充电，用户只需将充电器插入对应插座，通过微信扫描二维码完成支付即可开始充电，操作流程简洁直观。每台充电桩配备10个充电端口，支持多车同时充电，有效满足了地铁口高密度停车充电的需求。
          </p>

          <figure class="figure_block">
            <img
              class="article_img"
              :src="images.img3"
              alt="用户扫码充电"
            >
            <figcaption class="figure_caption">用户正在使用微信扫码充电</figcaption>
          </figure>

          <p class="body_paragraph">
            设备在安全方面同样做足了功课。充电桩由中国人寿财产保险股份有限公司承保，内置多重安全保护机制，具备过流保护、过压保护、短路保护及漏电保护等功能，从硬件层面切实防范充电环节的安全隐患，为市民提供安心可靠的充电体验。
          </p>

          <figure class="figure_block">
            <img
              class="article_img"
              :src="images.img7"
              alt="智能充电桩操作面板"
            >
            <figcaption class="figure_caption">智能充电桩操作面板 &mdash; 支持微信扫码充电</figcaption>
          </figure>

          <h2 class="section_title">四、现场运营情况</h2>

          <p class="body_paragraph">
            2026年7月1日，我司工作人员前往和谐广场地铁口现场检查设备运营情况。现场可以看到，充电桩设备运行状态良好，多台电动车正在使用充电服务，用户扫码操作流程顺畅。充电桩与非机动车停放区的整体布局协调有序，既提升了区域环境面貌，也为市民出行提供了实实在在的便利。
          </p>

          <figure class="figure_block">
            <img
              class="article_img"
              :src="images.img6"
              alt="现场运营情况"
            >
            <figcaption class="figure_caption">现场运营情况 &mdash; 充电桩设备运行状态良好，多台电动车正在使用充电服务</figcaption>
          </figure>

          <h2 class="section_title">五、合作展望</h2>

          <p class="body_paragraph">
            此次济南和谐广场地铁口充电桩的成功落地，是我司与济南静态交通集团深化合作的重要里程碑，标志着双方从考察交流阶段迈入了实质性项目运营阶段。未来，双方将在首批试点经验的基础上，进一步扩大合作规模，探索在更多地铁出入口及城市公共区域部署智能充电设施，同时积极探索智能化充电管理方案、充电设施网络化覆盖等创新业务，为济南市非机动车治理和绿色出行贡献更大力量。
          </p>
        </div>
      </article>
    </div>

    <div class="news_detail_page_foot">
      <CallMe/>
      <MobileCallme/>
    </div>
  </div>
</template>

<script>
import PCNavbar from '@/components/report_list/SpaNav.vue'
import MobileNavBar from '@/components/navbar/MobileNavBar.vue'
import CallMe from '@/components/callme/index'
import MobileCallme from '@/components/callme/MobileCallme.vue'

export default {
  components: {
    PCNavbar,
    MobileNavBar,
    CallMe,
    MobileCallme,
  },
  data () {
    return {
      images: {
        img1: require('@/assets/images/news-list/news3/image1.jpg'),
        img2: require('@/assets/images/news-list/news3/image2.jpg'),
        img3: require('@/assets/images/news-list/news3/image3.jpg'),
        img4: require('@/assets/images/news-list/news3/image4.jpg'),
        img6: require('@/assets/images/news-list/news3/image6.jpg'),
        img7: require('@/assets/images/news-list/news3/image7.jpg'),
      },
    }
  },
}
</script>

<style lang="scss">
@import '~@/assets/styles/news-detail-responsive.scss';
</style>
